import type { InternalAxiosRequestConfig } from 'axios'

// Endpoints that should NOT include X-Team-Context header
const TEAM_CONTEXT_EXCLUDED_ENDPOINTS = [
  '/auth/login',
  '/auth/register',
  '/auth/refresh-token',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/accept-invitation',
  '/auth/teams',
  '/auth/me/teams',
  '/auth/set-team-context',
  '/auth/validate-team-context',
  '/business-users/me/profile-image',
  '/business-users/me',
]

/**
 * Check if endpoint should have team context header
 */
const shouldIncludeTeamContext = (url: string | undefined): boolean => {
  if (!url) return false
  return !TEAM_CONTEXT_EXCLUDED_ENDPOINTS.some(endpoint => url.includes(endpoint))
}

export const requestInterceptor = [
  (config: InternalAxiosRequestConfig) => {
    // Get auth data from Zustand persist storage
    const authStorage = localStorage.getItem('auth-storage')
    if (authStorage) {
      try {
        const parsedAuth = JSON.parse(authStorage)
        const token = parsedAuth.state?.token
        const currentTeamId = parsedAuth.state?.currentTeamId

        config.headers = config.headers || {}

        // Add Authorization header
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }

        // Add X-Team-Context header for RBAC
        // The header is used by the backend for team context - no need to inject team_id into body
        if (currentTeamId && shouldIncludeTeamContext(config.url)) {
          config.headers['X-Team-Context'] = currentTeamId
        }
      } catch (error) {
        // Error parsing auth storage - fail silently
      }
    }

    // If data is FormData, delete Content-Type to let browser set it
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }

    return config
  },
  (error: unknown) => Promise.reject(error)
]